/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'fabric.elements.mentions.team.member.50plus': 'チーム • 50 人以上のメンバー',
  'fabric.elements.mentions.team.member.50plus.including.you': 'チーム • あなたを含む 50 人以上のメンバー',
  'fabric.elements.mentions.team.member.count': '{0, plural, other {チーム • {0} 人のメンバー}}',
  'fabric.elements.mentions.team.member.count.including.you':
    '{0, plural, other {チーム • あなたを含む {0} 人のメンバー}}',
  'fabric.elements.mentions.xproduct.mention.description': 'Confluence へのアクセス権を必要としています',
  'fabric.mention.error.defaultAction': '数秒後にもう一度お試しください',
  'fabric.mention.error.defaultHeadline': '問題が発生しました',
  'fabric.mention.error.differentText': '別のテキストを入力してください',
  'fabric.mention.error.loginAgain': '一度ログアウトしてからもう一度ログインしてみてください',
  'fabric.mention.noAccess.label': 'アクセス権限がありません',
  'fabric.mention.noAccess.warning': '{name} さんはアクセス権限がないため、通知されません',
  'fabric.mention.unknow.user.error': '不明なユーザー: {userId}',
};
